class ProductCardForm extends HTMLElement {
  constructor() {
      super();

      console.log('ProductCardForm initialized');

      this.initializeElements();
      this.initializeState();

      if (this.optionSelects.length > 0) {
          this.bindEvents();
          this.updateVariantSelect();
          this.updateOptionAvailability();
      }
  }

  initializeElements() {
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.optionSelects = this.querySelectorAll('[data-option-buttons]');
      this.form = this.querySelector('form');
      this.priceList = this.closest('.product-card__info').querySelector('price-list');

      if (!this.variantSelect || !this.form || !this.priceList) {
          console.error('Required elements not found in ProductCardForm');
      }
  }

  initializeState() {
      this.currentOptions = Array.from(this.optionSelects).map(select => 
          select.value || null
      );
  }

  bindEvents() {
      this.optionSelects.forEach(select => {
          select.addEventListener('change', (event) => {
              this.onOptionChange(event);
          });
      });
  }

  onOptionChange(event) {
      const select = event.currentTarget;
      const optionIndex = Array.from(this.optionSelects).indexOf(select);
      
      this.currentOptions[optionIndex] = select.value;

      this.updateVariantSelect();
      this.updateOptionAvailability();
      this.updatePrices();
  }

  updatePrices() {
      const selectedVariant = this.findVariantFromOptions();
      if (!selectedVariant) return;

      const { salePrice, comparePrice } = this.getPriceElements();
      this.updateSalePrice(salePrice, selectedVariant);
      this.updateComparePrice(comparePrice, selectedVariant);
  }

  getPriceElements() {
      return {
          salePrice: this.priceList.querySelector('sale-price'),
          comparePrice: this.priceList.querySelector('compare-at-price')
      };
  }

  updateSalePrice(salePrice, variant) {
      if (!salePrice) return;

      const formattedPrice = this.formatMoney(variant.price);
      const prefix = this.hasMultipleVariants() ? 'From ' : '';
      salePrice.innerHTML = `<span class="sr-only">Sale price</span>${formattedPrice}`;
  }

  updateComparePrice(comparePrice, variant) {
      if (!comparePrice) return;

      const hasDiscount = variant.compare_at_price > variant.price;
      if (hasDiscount) {
          const formattedComparePrice = this.formatMoney(variant.compare_at_price);
          comparePrice.innerHTML = `<span class="sr-only">Regular price</span>${formattedComparePrice}`;
          comparePrice.style.display = '';
      } else {
          comparePrice.style.display = 'none';
      }
  }

  formatMoney(cents) {
      const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
      return window.theme?.Currency?.formatMoney(cents, moneyFormat) || `$${(cents/100).toFixed(2)}`;
  }

  updateVariantSelect() {
      const selectedVariant = this.findVariantFromOptions();

      if (selectedVariant) {
          this.variantSelect.value = selectedVariant.id;
          this.toggleAddToCartButton(!selectedVariant.available);
      } else {
          this.toggleAddToCartButton(true);
      }
  }

  findVariantFromOptions() {
      const variants = this.getVariantData();
      return variants.find(variant => {
          return !variant.options.map((option, index) => {
              return this.currentOptions[index] === option;
          }).includes(false);
      });
  }

  updateOptionAvailability() {
      const variants = this.getVariantData();
      const selectedOptions = [...this.currentOptions];

      this.optionSelects.forEach((select, optionIndex) => {
          Array.from(select.options).forEach(option => {
              const optionValue = option.value;
              const tempOptions = [...selectedOptions];
              tempOptions[optionIndex] = optionValue;

              const availableVariant = variants.find(variant => {
                  return !variant.options.map((opt, index) => {
                      return tempOptions[index] === null || tempOptions[index] === opt;
                  }).includes(false) && variant.available;
              });

              option.disabled = !availableVariant;
          });
      });
  }

  toggleAddToCartButton(disabled) {
      const addToCartButton = this.querySelector('[type="submit"]');
      if (addToCartButton) {
          addToCartButton.disabled = disabled;
      }
  }

  getVariantData() {
      if (!this.variantData) {
          const variantElement = document.getElementById(`product-variants-${this.id}`);
          if (!variantElement) {
              console.error(`Variant data element not found for form ID: ${this.id}`);
              return [];
          }
          try {
              this.variantData = JSON.parse(variantElement.textContent);
          } catch (error) {
              console.error('Failed to parse variant data:', error);
              return [];
          }
      }
      return this.variantData;
  }

  hasMultipleVariants() {
      const variants = this.getVariantData();
      return variants.length > 1;
  }
}

customElements.define('product-card-form', ProductCardForm);